import { Folder, FolderOpen } from "lucide-react";

import { useLinkContext } from "./link-context";
import { useMenu } from "../../../store/global/useMenu";

export function LinkSubmenuIcon() {
  const ctx = useLinkContext()
  const isOpen = useMenu(st => st.data.open)
  const item = useMenu(st => st.data.itens[ctx.name])

  if (!isOpen) return null
  return (
    <span>
      {!item.open && <Folder className="w-5 h-5" />}
      {item.open && <FolderOpen className="w-5 h-5" />}
    </span>
  );
}
